const ActionButtons = ({ isLoading, label, onClose }) => {
    return (
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
            <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-red-600 dark:text-red-200 
                     hover:bg-red-100 dark:hover:bg-red-700 rounded-lg transition-colors"
                disabled={isLoading}
            >
                Cancel
            </button>

            <button
                type="submit"
                disabled={isLoading}
                className="px-4 py-2 text-sm font-medium text-white bg-[#3590BA] 
                     hover:bg-[#3590BA]/80 rounded-lg transition-colors
                     disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {isLoading ? label.loadingLabel : label.normalLabel}
            </button>
        </div>
    );
};

export default ActionButtons;
